<template>
  <div class="cw-form">
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      label-width="120px"
      style="overflow: auto"
    >
      <div style="text-align: right">
        <el-button
          size="small"
          style="background: cornflowerblue; color: white; margin-right: 10px"
          :loading="printing"
          @click="print"
        >打印<span v-if="printing">中...</span></el-button>
        <el-button-export
          :url="downloadUrl"
          size="small"
          type="success"
        >下载</el-button-export>
      </div>
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="详细信息" name="first">
          <el-scrollbar>
            <table style="width: 99%">
              <tr>
                <td colspan="4">
                  <h2 style="text-align: center">送 货 单</h2>
                </td>
              </tr>
              <tr>
                <td style="width: 35%">
                  购货单位: {{ form.deliveryMessageInfo.fBillingName }}
                </td>
                <td style="width: 35%">
                  客户名称: {{ form.deliveryMessageInfo.fCustomer }}
                </td>
                <td style="width: 15%">
                  日期:{{ form.deliveryMessageInfo.fDate }}
                </td>
                <td style="width: 15%">
                  NO:{{ form.deliveryMessageInfo.fCkBillNo }}
                </td>
              </tr>
              <tr>
                <td style="width: 35%">
                  经营许可证号/备案凭证号:
                  {{ form.deliveryMessageInfo.fBusinessNo }}
                </td>
                <td style="width: 35%">
                  经营地址:
                  {{ form.deliveryMessageInfo.fAddress_jy }}
                </td>
                <td colspan="2">发货日期:{{ form.deliveryMessageInfo.date_fh }}</td>
              </tr>
              <tr>
                <td style="width: 35%">
                  送货地址:
                  {{ form.deliveryMessageInfo.fAddress_sh }}
                </td>
                <td style="width: 35%">
                  联系电话:
                  {{ form.deliveryMessageInfo.fPhone }}
                </td>
                <td colspan="2">供货单位:{{ form.deliveryMessageInfo.fSupplier }}</td>
              </tr>
              <tr>
                <td colspan="4">
                  <table class="tableDetails">
                    <tr>
                      <th>名称</th>
                      <th>型号/规格</th>
                      <th style="width: 50px">单位</th>
                      <th style="width: 50px">数量</th>
                      <th style="width: 50px">单价</th>
                      <th style="width: 50px">金额</th>
                      <th style="width: 100px">生产批号</th>
                      <th style="width: 100px">生产日期</th>
                      <th style="width: 100px">失效日期</th>
                      <th>序列号（追溯号）</th>
                      <th style="width: 300px">储运条件</th>
                      <th>注册证号/备案凭证编号</th>
                      <th style="width: 50px">医疗器械注册人/备案人</th>
                      <th>生产企业</th>
                      <th>生产企业许可证号/备案凭证编号</th>
                    </tr>
                    <tr
                      v-for="(item, index) in form.deliveryMessageInfo.entrys"
                      :key="index"
                      style="word-break: break-all"
                    >
                      <td>{{ item.fName }}</td>
                      <td>{{ item.fModel }}</td>
                      <td>{{ item.fUnit }}</td>
                      <td>{{ item.fQty }}</td>
                      <td>{{ item.fPrice_fh }}</td>
                      <td>{{ item.fTotal }}</td>
                      <td>{{ item.fBatchNo }}</td>
                      <td>{{ item.fDate_Sc }}</td>
                      <td>{{ item.expiryDate }}</td>
                      <td>{{ item.fRetroactiveNo }}</td>
                      <td>{{ item.fTransportDes }}</td>
                      <td>{{ item.fRegisterNumber }}</td>
                      <td>{{ item.fRegistrar }}</td>
                      <td>{{ item.fProduction }}</td>
                      <td>{{ item.fProductionNumber }}</td>
                    </tr>
                    <tr>
                      <td colspan="5">合 计</td>
                      <td colspan="10" style="text-align: left">
                        {{ form.deliveryMessageInfo.fAmount }}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  送货单位及经手人(盖章):{{
                    form.deliveryMessageInfo.fCheckName
                  }}
                  <img
                    v-if="form.deliveryMessageInfo.fSealUrl1"
                    class="imgYZ"
                    :src="form.deliveryMessageInfo.fSealUrl1"
                  >
                </td>
                <td 
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    width: 300px;
                  "
                >
                  收货单位及经手人(盖章):
                  <img
                    v-if="form.deliveryMessageInfo.fSealUrl2"
                    class="imgYZ"
                    :src="form.deliveryMessageInfo.fSealUrl2"
                  >
                </td>
              </tr>
            </table>
          </el-scrollbar>
        </el-tab-pane>
        <el-tab-pane label="发票信息" name="fourth">
          <el-form label-width="150px">
            <!-- {{ form.fpInfo }} -->
            <el-col :span="8">
              <el-form-item label="发票类型">
                <el-input :value="form.fpInfo.fFpType" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="单位名称">
                <el-input :value="form.fpInfo.fDw" readonly /> </el-form-item></el-col>
            <el-col :span="8">
              <el-form-item label="社会统一信用代码">
                <el-input
                  :value="form.fpInfo.fShNumber"
                  readonly
                /> </el-form-item></el-col>
            <el-col :span="8">
              <el-form-item label="地址">
                <el-input
                  :value="form.fpInfo.fAddress"
                  readonly
                /> </el-form-item></el-col>
            <el-col :span="8">
              <el-form-item label="电话">
                <el-input :value="form.fpInfo.fPhone" readonly /> </el-form-item></el-col>
            <el-col :span="8">
              <el-form-item label="开户行名称">
                <el-input
                  :value="form.fpInfo.fBankName"
                  readonly
                /> </el-form-item></el-col>
            <el-col :span="8">
              <el-form-item label="印章">
                <el-input :value="form.fpInfo.fSeal" readonly />
                <p>
                  <img
                    v-if="form.fpInfo.fSealUrl"
                    :src="form.fpInfo.fSealUrl"
                    style="width: 150px"
                  >
                </p>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="发票邮寄地址">
                <el-input
                  :value="form.fpInfo.fAddress_fp"
                  readonly
                /> </el-form-item></el-col>
            <el-col :span="8">
              <el-form-item label="开户行账号">
                <el-input :value="form.fpInfo.fBankNumber" readonly />
              </el-form-item>
            </el-col>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="物流信息" name="fifth">
          <el-form label-width="150px" class="wlinfo">
            <el-form-item label="快递公司">
              <el-input :value="form.fKdCompany" disabled />
            </el-form-item>
            <el-form-item label="物流单号">
              <el-input :value="form.fKdNumber" disabled />
              <el-link
                v-if="form.fKdNumberUrl"
                type="primary"
                :href="form.fKdNumberUrl"
                target="_blank"
                style="margin-left: 10px"
              >查询</el-link>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="单据流程" name="third">
          <el-table :data="form.procedureMessage" height="100%">
            <el-table-column label="流程步骤" prop="fName" />
            <el-table-column label="处理人" prop="fUserName" />
            <el-table-column label="状态" prop="fState" />
            <el-table-column
              label="日期"
              prop="fDate"
              :formatter="dateTimeFormat"
            />
            <el-table-column label="意见" prop="fOpinion" />
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <iframe
        style="display: none"
      ><Print id="printVoucher" ref="printVoucher"></Print
        ></iframe>
    </el-form>
  </div>
</template>

<script>
import { Now, Today, DeepCopy } from '@assets/site'
import moment from 'moment'
// import Print from "../commonPrint/Print";
import Print from './Print'

import printnb from '@plugins/vue-print-nb-printarea'

export default {
  components: { Print },

  data: function() {
    return {
      form: {
        fpInfo: {},
        procedureInfo: {},
        deliveryMessageInfo: { entrys: [] },
        procedureMessage: [],
        entrys: []
      },

      rules: {},
      printing: false,

      activeName: 'first',

      saving: false,
      loading: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.routePath || vm.routePath != to.fullPath) {
        vm.routePath = to.fullPath
        vm.refresh()
      }
    })
  },
  beforeRouteUpdate: function(to, from, next) {
    next()
    const vm = this
    vm.routePath = to.fullPath
    vm.refresh()
  },
  computed: {},
  methods: {
    refresh: async function(fid) {
      const id = fid || +this.$route.params.id

      this.loading = true
      const res = await this.$httpPost(
        'BusinessManage/DeliveryForCw/GetDeliveryForCw',
        { fid: id }
      ).finally(() => (this.loading = false))

      if (!res.isSuccess) {
        this.$message.error(res.message)
        return
      }

      this.form = res.datalist
    },
    print: async function() {
      this.printing = true
      const success = await this.$refs.printVoucher.refresh(this.form.fid)
      if (!success) {
        this.printing = false
        return
      }

      // https://www.npmjs.com/package/vue-print-nb
      new printnb({
        ids: 'printVoucher', // * 局部打印必传入id
        standard: '', // 文档类型，默认是html5，可选 html5，loose，strict
        extraHead: '', // 附加在head标签上的额外标签,使用逗号分隔
        extraCss: '', // 额外的css连接，多个逗号分开
        popTitle: '', // title的标题
        endCallback() {
          // 调用打印之后的回调事件
        }
      })
      setTimeout(() => {
        this.printing = false
      }, 100)
    },
    downloadUrl: function() {
      return this.$buildDownloadUrl('Download/DeliveryDownload', {
        fid: this.form.fid
      })
    },
    dateTimeFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    dateFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>

<style lang="less">
.cw-form {
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .el-tabs {
    .el-tabs__content {
      height: calc(100vh - 200px);
      .el-tab-pane {
        height: calc(100vh - 200px);
      }
    }
  }
}
</style>
<style lang="less" scoped>
.cw-form {
  .wlinfo {
    .el-input,
    .el-select,
    .el-autocomplete {
      width: 20% !important;
    }
  }

  .tableDetails {
    width: 100%;
    border-collapse: collapse;
  }

  .tableDetails,
  .tableDetails td,
  .tableDetails th {
    border: 1px solid black;
    text-align: center;
  }

  .tableDetails td,
  .tableDetails th {
    padding: 5px;
  }

  .imgYZ {
    width: 100px;
    height: 100px;
    border-width: 0px;
    vertical-align: middle;
  }
}
</style>
